import { render, staticRenderFns } from "./b-label.global.vue?vue&type=template&id=34e1533a"
import script from "./b-label.global.vue?vue&type=script&lang=js"
export * from "./b-label.global.vue?vue&type=script&lang=js"
import style0 from "./b-label.global.vue?vue&type=style&index=0&id=34e1533a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
